import { api } from '@/lib/axios-client'
import type {
  TemplateFormData,
  TemplateListItems,
  TemplateVersionsResponse,
  TemplateVersionSummary,
  PredefinedItem,
  DocumentKindOption,
  CreateTemplateVersionPayload,
} from '../types/permit-template-types'
import type { ApiResponse } from '@/types/permits'

export const getPredefinedItems = async (): Promise<PredefinedItem[]> => {
  const response = await api.get<PredefinedItem[]>('/PredefinedList/Get')
  return response
}

export const getDocumentKinds = async (): Promise<DocumentKindOption[]> => {
  const response = await api.get<DocumentKindOption[]>(
    '/Template/DocumentKinds',
  )
  return response
}

export const saveTemplate = async (
  payload: TemplateFormData,
): Promise<string> => {
  const response = await api.post<ApiResponse<string>>(
    '/Template/Add',
    sanitizeTemplatePayload(payload),
  )
  return response.data
}

const isLocalId = (id: string) =>
  id.startsWith('doc-') || id.startsWith('entity-') || id.startsWith('item-')

const sanitizeId = (id: string) => {
  if (!id || isLocalId(id)) return null
  return id
}

const sanitizeTemplatePayload = (
  template: TemplateFormData,
): TemplateFormData =>
  ({
    ...template,
    requiredDocuments: template.requiredDocuments.map((doc) => ({
      ...doc,
      id: sanitizeId(doc.id),
      entities: doc.entities.map((entity) => ({
        ...entity,
        id: sanitizeId(entity.id),
        selectedItems: entity.selectedItems.map((item) => ({
          ...item,
          id: sanitizeId(item.id),
        })),
      })),
    })),
  }) as TemplateFormData
export const updateTemplate = async (
  template: TemplateFormData,
): Promise<TemplateFormData> => {
  const response = await api.put<TemplateFormData>(
    '/Template/Update',
    sanitizeTemplatePayload(template),
  )
  return response
}
export const AddTemplateVersion = async (
  template: CreateTemplateVersionPayload,
): Promise<string> => {
  const response = await api.post<ApiResponse<string>>(
    `/Template/AddVersion`,
    template,
  )
  return response.data
}
export const getTemplateVersions = async (
  id: string,
): Promise<TemplateVersionsResponse> => {
  const data = await api.get<TemplateVersionsResponse>(
    `/Template/Id?TemplateId=${id}`,
  )
  return data
}
export const getTemplateById = async (
  id: string,
): Promise<TemplateFormData | null> => {
  const data = await api.get<TemplateFormData>(
    `/Template/TemplateVersionId?TemplateVersionId=${id}`,
  )
  if (!data) {
    return null
  }

  return data
}

export const getTemplatesByCityId = async (
  _cityId: string,
  pageNumber = 0,
  pageSize = 0,
): Promise<TemplateListItems> => {
  const data = await api.post<TemplateListItems>(
    `/Template/List?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    {},
  )
  return data
}

export const getTemplatesVersions = async (
  search: string = '',
): Promise<TemplateVersionSummary[]> => {
  const data = await api.post<TemplateVersionSummary[]>(`/Template/Versions`, {
    search: search,
  })
  return data
}
